import { FC, useMemo, useCallback } from 'react'
import * as styles from 'components/features/socialFeed/FeedPostList/FeedPostList.styl'
import { selectFeedFilterActionCreator } from 'actions/feedActions'
import { EmptyCardBlock } from 'components/features/pfm/Blocks/Blocks'
import { NavigationBack } from 'components/atoms/navigation/NavigationBack'
import Button from 'components/features/pfm/Button/Button'
import { FeedResource } from 'interfaces/feed'
import { feedSelectedFilterSelector } from 'selectors/feedSelectors'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { useNativeHistory } from 'helpers/hookHelpers'

export type FeedPostListZeroStateProps = {
  resource?: FeedResource
}

export const FeedPostListZeroState: FC<FeedPostListZeroStateProps> = (props) => {
  const { resource } = props
  const selectedFilter = useStoreSelector(feedSelectedFilterSelector)
  const isAuthenticated = Boolean(useStoreSelector(isAuthenticatedSelector))
  const dispatch = useStoreDispatch()
  const onExplorePosts = useCallback(() => {
    dispatch(selectFeedFilterActionCreator({ type: 'feedgroup', slug: 'everyone' }))
  }, [dispatch])
  const { hasHistory } = useNativeHistory()

  const copyChild = useMemo(() => {
    if (resource && resource.type === 'user') {
      return (
        <p className={ styles.emptyPostListCopy }>
          This member has not created any posts yet.
        </p>
      )
    }

    if (selectedFilter && selectedFilter.type === 'your-posts') {
      return (
        <p className={ styles.emptyPostListCopy }>
          You have not created any posts yet.
        </p>
      )
    }

    if (selectedFilter && selectedFilter.type === 'feedgroup' && selectedFilter.slug === 'followed_people') {
      return (
        <p className={ styles.emptyPostListCopy }>
          There are no posts from people you follow yet.
        </p>
      )
    }

    if (selectedFilter && selectedFilter.type === 'feedgroup' && selectedFilter.slug === 'followed_tags') {
      return (
        <p className={ styles.emptyPostListCopy }>
          There are no posts from tags you follow yet.
        </p>
      )
    }

    if (selectedFilter && selectedFilter.type === 'feedgroup' && selectedFilter.slug === 'followed_posts') {
      return (
        <p className={ styles.emptyPostListCopy }>
          You're not following any posts yet.
        </p>
      )
    }

    return (
      <p className={ styles.emptyPostListCopy }>
        Looks like no one has posted anything to this group. Be the first!
      </p>
    )
  }, [resource, selectedFilter])

  const ctaChild = useMemo(() => {
    if (resource) {
      const text = hasHistory ? 'Go Back' : 'Go To Advice Feed'

      return (
        <NavigationBack>
          <Button style='hollow'>{ text }</Button>
        </NavigationBack>
      )
    }

    return (
      <Button style='hollow' onClick={ onExplorePosts }>Explore more posts</Button>
    )
  }, [resource, hasHistory, onExplorePosts])

  return (
    <EmptyCardBlock shadowTheme='soft'>
      { copyChild }
      { isAuthenticated && (
        <div className={ styles.zeroStateCtaWrapper }>
          { ctaChild }
        </div>
      )}
    </EmptyCardBlock>
  )

}
